// PACKAGES
import React, { Component } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";

// FILES
import translator from "../../utils/translator";

class AddNSuploader extends Component {
	constructor(props) {
		super(props);
        this.state = {
            image: {
                url: "",
                preview: "",
                filename: ""
            },
            spec: {
                url: "",
                preview: "",
                filename: ""
            }
        };
    }
    toast_config = {
        position: "bottom-center",
        autoClose: false,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
    };
    urls = {
        image: process.env.REACT_APP_PHP_API + "/images/_nonstock-images/",
        spec: process.env.REACT_APP_PHP_API + "/images/_nonstock-specs/"
    };

    defaults = {
        image: process.env.REACT_APP_PHP_API + "/images/LG_NotFound.jpg",
        spec: ""
    }
    imageTypes = [
        'image/jpeg',
        'image/png',
        'image/gif',
    ];
    specTypes = [
        'application/pdf',
    ];

    componentDidMount = async () => {
        this.setState(state => ({
            image: {
                ...state.image,
                url: this.defaults.image
            },
            spec: {
                ...state.spec,
                url: this.defaults.spec
            }
        }));
    };
    
    pick_file = (e, field) => {
        let reader = new FileReader();
        let file = e.target.files[0];

        if(file) {
            reader.onloadend = () => {
                this.setState(state => ({
                    [field]: {
                        ...state[field],
                        preview: reader.result,
                        filename: file.name
                    }
                }));
    
                this.props.update(field, reader.result);
            }
            reader.readAsDataURL(file);
        }
    }

    pickNsImage = (e, field) => {
        if(e.target.files.length <= 0) {
            return;
        }
        if(this.imageTypes.includes(e.target.files[0].type)) {
            this.pick_file(e, field);
        } else {
            toast.error(translator("Misc", "nonstock_image_formats"), 
            {
                position: "bottom-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
            });
        }
    }

    pickNsSpec = (e, field) => {
        if(e.target.files.length <= 0) {
            return;
        }
        if(!!e.target.files[0] && this.specTypes.includes(e.target.files[0].type)) {
            this.pick_file(e, field);
        } else {
            toast.error(translator("Misc", "nonstock_spec_formats"), 
            {
                position: "bottom-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
            });
        }
    }

    cancel_file = field => {
        this.setState(state => ({
            [field]: {
                ...state[field],
                preview: ""
            }
        }));
    }

	render() {
		return (
            <div className={"nsuploader upload"}>
                <div className={"nsuploader-section"}>
                    <div class="nsuploader-preview">
                        <img src={this.state.image.preview || this.state.image.url} alt="" />
                    </div>
                    {!!this.state.image.preview &&
                        <div className={"nsuploader-imagename"}>
                            {this.state.image.filename}
                        </div>
                    }
                    <div className={"nsuploader-button-wrapper"}>
                        <label className={"nsuploader-button green"}>
                            <input type="file" onChange={e => this.pickNsImage(e, "image")} />
                            {translator("Admin Consultant Settings", "choose_file_label")}
                        </label>
                        <button className={"nsuploader-button red"} onClick={() => this.cancel_file("image")}>
                            {translator("Misc", "cancel_btn")}
                        </button>
                    </div>
                    <div className="upload-note">{translator("Misc", "nonstock_image_formats")}</div>
                </div>
                <div className={"nsuploader-section"}>
                    <div class="nsuploader-preview-spec">
                        {!this.state.spec.preview && this.state.spec.url
                            ? (
                                <a className={"link"} target="_blank" href={this.state.spec.url} rel="noopener noreferrer">
                                    {translator("Misc", "current_document_label")}
                                </a>
                            )
                            : (
                                <div className={"label"}>
                                    {this.state.spec.filename || translator("Product Shopping", "no_spec_found")}
                                </div>
                            )
                        }
                    </div>
                    <div className={"nsuploader-button-wrapper"}>
                        <label className={"nsuploader-button green"}>
                            <input type="file" onChange={e => this.pickNsSpec(e, "spec")} />
                            {translator("Admin Consultant Settings", "choose_file_label")}
                        </label>
                        <button className={"nsuploader-button red"} onClick={() => this.cancel_file("spec")}>
                            {translator("Misc", "cancel_btn")}
                        </button>
                    </div>
                </div>
            </div>
		);
	}
}

const mapStateToProps = state => ({
	selected_language: state.selected_language,
});

const mapDispatchToProps = {};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(AddNSuploader);
